import React, { useEffect, useRef, useState } from 'react';
import { claveCanal, nombreCanal } from '../hooks/useOpcionesCapacidad';
import styles from './estudios-canales-horario.module.css';

// Selector múltiple de canales de equipo para un estudio del horario.
// Cada opción muestra cuántos equipos de ese canal tiene la sede.
// opciones: [{ canales, conCpap, etiqueta, equipos }] · seleccionados: ['4-0', '21-0'] (claves)
const MultiSelectCanales = ({ id, nombre, opciones, seleccionados, onChange, disabled, invalido }) => {
  const [abierto, setAbierto] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!abierto) return undefined;
    const alClickAfuera = (e) => { if (ref.current && !ref.current.contains(e.target)) setAbierto(false); };
    const alTeclear = (e) => { if (e.key === 'Escape') setAbierto(false); };
    document.addEventListener('mousedown', alClickAfuera);
    document.addEventListener('keydown', alTeclear);
    return () => {
      document.removeEventListener('mousedown', alClickAfuera);
      document.removeEventListener('keydown', alTeclear);
    };
  }, [abierto]);

  useEffect(() => { if (disabled) setAbierto(false); }, [disabled]);

  const toggle = (clave) => onChange(
    seleccionados.includes(clave) ? seleccionados.filter(c => c !== clave) : [...seleccionados, clave]
  );

  const resumen = opciones
    .filter(o => seleccionados.includes(claveCanal(o)))
    .map(nombreCanal)
    .join(', ');

  const idPanel = `${id}-opciones`;

  return (
    <div ref={ref} className={styles['multi-canal']}>
      <button
        type="button"
        id={id}
        className={`${styles['multi-canal-boton']} ${invalido ? styles['fila-canal-falta'] : ''}`}
        aria-label={`Canales de ${nombre}${resumen ? `: ${resumen}` : invalido ? ': falta elegir al menos uno' : ''}`}
        aria-haspopup="true"
        aria-expanded={abierto}
        aria-controls={idPanel}
        disabled={disabled}
        onClick={() => setAbierto(a => !a)}
      >
        <span className={styles['multi-canal-texto']}>
          {resumen || (opciones.length === 0 ? 'Sin canal en la sede' : 'Elegir canal...')}
        </span>
        <span aria-hidden="true">▾</span>
      </button>
      {abierto && (
        <div id={idPanel} className={styles['multi-canal-panel']} role="group" aria-label={`Canales para ${nombre}`}>
          {opciones.length === 0 && <p className={styles['panel-vacio']}>La sede no tiene canales que sirvan para este estudio.</p>}
          {opciones.map(o => {
            const clave = claveCanal(o);
            const idOpcion = `${id}-${clave}`;
            return (
              <label key={clave} htmlFor={idOpcion} className={styles['multi-canal-opcion']}>
                <input id={idOpcion} type="checkbox" checked={seleccionados.includes(clave)} onChange={() => toggle(clave)} />
                <span>{nombreCanal(o)}</span>
                <small className={styles['fila-ayuda']}>{o.equipos} {o.equipos === 1 ? 'equipo' : 'equipos'} en la sede</small>
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MultiSelectCanales;
